import React, { Component } from 'react';

import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';

import { useSSE } from './hooks/useSSE';
import Navbar from './components/navbar.jsx';
import Footer from './components/footer.jsx';

import Home from './components/home.jsx';
import Login from './components/login.jsx';
import Logout from './components/logout.jsx';
import Randevular from './components/randevular.jsx';
import Randevu from './components/randevu.jsx';
import RandevuEkle from './components/randevuekle.jsx';
import GelecekRandevular from './components/gelecek-randevular.jsx';
import GunlukRandevular from './components/gunluk-randevular.jsx';
import IptalEdilenler from './components/iptal-edilenler.jsx';
import Takvim from './components/takvim.jsx';
import KullaniciEkle from './components/kullanici-ekle.jsx';
import PrivateRoute from './components/privateroute.jsx';
import AdminRoute from './components/adminroute.jsx';


function SSEConnector() {
  useSSE();
  return null;
}

class App extends Component {
  render() {
    return (
      <Router>
        <div className="min-h-screen bg-slate-50 flex flex-col font-sans text-slate-900 selection:bg-sky-200 selection:text-sky-900">
          <SSEConnector />
          <Navbar />
          <main className="flex-1 w-full max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
            <Switch>
              <Route exact path="/" component={Home} />
              <Route path="/user/login" component={Login} />
              <Route path="/user/logout" component={Logout} />
              <PrivateRoute exact path="/randevular" component={Randevular} />
              <PrivateRoute exact path="/gelecek-randevular" component={GelecekRandevular} />
              <PrivateRoute exact path="/gunluk-randevular" component={GunlukRandevular} />
              <PrivateRoute exact path="/iptal-edilenler" component={IptalEdilenler} />
              <PrivateRoute exact path="/takvim" component={Takvim} />
              <PrivateRoute exact path="/randevu-ekle" component={RandevuEkle} />
              <PrivateRoute path="/randevu-duzenle/:uuid" component={RandevuEkle} />
              <PrivateRoute path="/randevu/:uuid" component={Randevu} />
              <AdminRoute exact path="/kullanici-ekle" component={KullaniciEkle} />
            </Switch>
          </main>
          <Footer />
        </div>
      </Router>
    );
  }
}

export default App
